export const environment = {
  production: true,
  apiUrl: 'https://dev-v2.click2sell.com',
  wsUrl: 'wss://dev-v2.click2sell.com/ws',
  userSnapApiKey: 'f91dd051-b6ad-4a42-9f02-7dd8c49e98fd',
  name: 'development',
};
